$(function() {
    "use strict";
    $(".store-picker").on("change", function() {
        const value = $(this).val();

        if (value.length) {
            $(".event-link").not("." + value).hide();
            $(".event-link." + value).show();
        } else {
            $(".event-link").show();
        }
    });
});
